import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { 
    FaEdit, FaPlus, FaCheck, FaTimes, FaLayerGroup, 
    FaLink, FaSortAmountDown, FaSearch, FaFilter,
    FaChevronLeft, FaChevronRight, FaSync 
} from 'react-icons/fa';
import './css/BonusManagement.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BonusManagement = () => {
    // --- STATE TANIMLAMALARI ---
    const [bonuses, setBonuses] = useState([]);
    const [categories, setCategories] = useState([]); //
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentBonus, setCurrentBonus] = useState(null);

    // --- KATEGORİ YÖNETİMİ İÇİN YENİ STATELER ---
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [isSubmittingCat, setIsSubmittingCat] = useState(false);
    
    // Sistem Durumu Stateleri
    const [isSystemActive, setIsSystemActive] = useState(true);
    const [loadingStatus, setLoadingStatus] = useState(true);

    // Filtre & Sayfalama Stateleri
    const [searchTerm, setSearchTerm] = useState('');
    const [filterVisible, setFilterVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const [formData, setFormData] = useState({
        name: '', bonusType: '', bonusPercent: 0, category: '',
        order: 0, status: true, minDepositAmount: 0, maxDepositAmount: 0,
        minAmount: 0, maxAmount: 0, boPanelID: 0, boPanelType: 0
    });

    // --- SİSTEM DURUMU ÇEKME (DataTable'daki gibi) ---
    const fetchSystemStatus = () => {
        axiosInstance.get('/siteSettings')
            .then(response => {
                setIsSystemActive(response.data.bonusRequestsEnabled);
            })
            .catch(error => console.error("Sistem durumu çekilemedi:", error))
            .finally(() => setLoadingStatus(false));
    };

    // --- KATEGORİLERİ ÇEKME ---
    const fetchCategories = async () => {
        try {
            // Backend'de bonus controller içinde /categories endpoint'i olduğunu varsayıyorum
            const res = await axiosInstance.get('/bonus/categories');
            setCategories(res.data);
        } catch (err) {
            console.error("Kategoriler yüklenemedi");
        }
    };

    const handleDeleteCategory = async (id) => {
        if (!window.confirm("Bu kategoriyi silmek istediğinize emin misiniz?")) return;
        try {
            await axiosInstance.delete(`/bonus/categories/${id}`);
            toast.success("Kategori başarıyla silindi.");
            fetchCategories(); // Listeyi güncelle
        } catch (err) {
            toast.error("Kategori silinirken bir hata oluştu.");
        }
    };
    const handleAddCategory = async (e) => {
        e.preventDefault();
        if (!newCategoryName.trim()) return;

        setIsSubmittingCat(true);
        try {
            // Backend'de categoryId'yi otomatik artan veya benzersiz bir sayı atadığını varsayıyorum
            await axiosInstance.post('/bonus/categories', { name: newCategoryName });
            toast.success("Yeni kategori eklendi!");
            setNewCategoryName('');
            fetchCategories(); // Listeyi güncelle
        } catch (err) {
            toast.error("Ekleme başarısız.");
        } finally {
            setIsSubmittingCat(false);
        }
    };

    // --- ID'DEN KATEGORİ ADI BULMA ---
    const getCategoryName = (catId) => {
        const category = categories.find(c => Number(c.categoryId) === Number(catId));
        return category ? category.name : "Belirsiz";
    };

    const fetchBonuses = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get('/bonus/all');
            setBonuses(res.data);
        } catch (err) {
            toast.error("Bonuslar yüklenemedi.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBonuses();
        fetchCategories(); // Sayfa açılınca kategorileri çek
        fetchSystemStatus();
        fetchBonuses();
        fetchSystemStatus();

        const interval = setInterval(fetchSystemStatus, 20000);
        return () => clearInterval(interval);
    }, []);

    // --- FİLTRELEME & SAYFALAMA MANTIĞI ---
    const filteredBonuses = bonuses.filter(bonus =>
        bonus.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bonus.bonusType?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredBonuses.length / itemsPerPage);
    const currentItems = filteredBonuses.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const paginate = (num) => {
        setCurrentPage(num);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // --- FORM İŞLEMLERİ ---
    const handleEdit = (bonus) => {
        setCurrentBonus(bonus);
        setFormData({ ...bonus });
        setShowModal(true);
    };

    const handleAddNew = () => {
        setCurrentBonus(null);
        setFormData({
            name: '', bonusType: '', bonusPercent: 0, category: '',
            order: 0, status: true, minDepositAmount: 0, maxDepositAmount: 0,
            minAmount: 0, maxAmount: 0, boPanelID: 0, boPanelType: 0
        });
        setShowModal(true);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : (type === 'number' ? Number(value) : value)
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (currentBonus) {
                await axiosInstance.put(`/bonus/update/${currentBonus._id}`, formData);
                toast.success("Bonus başarıyla güncellendi! 🍃");
            } else {
                await axiosInstance.post('/bonus/create', formData);
                toast.success("Yeni bonus oluşturuldu! 🍃");
            }
            setShowModal(false);
            fetchBonuses();
        } catch (err) {
            toast.error(`Hata: ${err.response?.data?.message || "İşlem başarısız"}`);
        }
    };

    const getPercentColor = (percent) => {
        if (percent <= 20) return '#10b981';
        if (percent <= 50) return '#f27127';
        return '#ef4444';
    };

    return (
        <div className="data-page-container">
            <header className="header-card">
                <div className="header-info">
                    <div className="title-with-icon">
                        <FaLayerGroup className="title-icon" />
                        <div>
                            <h2>Bonus Yönetimi <span className="count-badge">{filteredBonuses.length}</span></h2>
                            <p>Yönetim Paneli • Canlı Kontrol</p>
                        </div>
                    </div>
                </div>

                <div className="action-group">
                    {/* --- DİNAMİK SİSTEM GÖSTERGESİ --- */}
                    <div className={`system-indicator ${isSystemActive ? 'active' : 'passive'}`}>
                        <div className={`status-dot ${isSystemActive ? 'pulse' : ''}`}></div>
                        {loadingStatus ? '...' : (isSystemActive ? 'Sistem Aktif' : 'Sistem Kapalı')}
                    </div>

                    <button className={`btn-modern btn-filter ${filterVisible ? 'active' : ''}`} onClick={() => setFilterVisible(!filterVisible)}>
                        <FaFilter /> {filterVisible ? 'Kapat' : 'Filtrele'}
                    </button>
                    <button className="btn-modern btn-category-manage" onClick={() => setShowCategoryModal(true)}>
        <FaLayerGroup /> Kategorileri Yönet
    </button>
                    <button className="btn-modern btn-add-bonus" onClick={handleAddNew}>
                        <FaPlus /> Yeni Bonus Ekle
                    </button>
                </div>
            </header>

            {filterVisible && (
                <div className="search-bar-container" style={{ marginBottom: '20px' }}>
                    <FaSearch className="search-icon" />
                    <input
                        type="text"
                        placeholder="Bonus ismi veya koduna göre ara..."
                        value={searchTerm}
                        onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    />
                </div>
            )}

            <div className="table-container">
                <table className="modern-table">
                    <thead>
                        <tr>
                            <th className="th-center">KOD</th>
                            <th>BONUS DETAYI</th>
                            <th className="th-center">ORAN</th>
                            <th>YATIRIM ŞARTLARI</th>
                            <th>BONUS LİMİTLERİ</th>
                            <th>PANEL BAĞLANTISI</th>
                            <th className="th-center">DURUM</th>
                            <th className="th-center">İŞLEM</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="8" className="empty-state">Veri akışı bekleniyor...</td></tr>
                        ) : currentItems.map((bonus) => (
                            <tr key={bonus._id} className="table-row">
                                <td className="td-center"><div className="bonus-id-badge"><span>{bonus.bonusType}</span></div></td>
                                <td>
                                    <div className="b-main-cell">
                                        <span className="b-title">{bonus.name}</span>
                                        <div className="b-tags">
                                            <span className="tag-category">{getCategoryName(bonus.category) || 'Genel'}</span>
                                            <span className="tag-order"><FaSortAmountDown /> #{bonus.order}</span>
                                        </div>
                                    </div>
                                </td>
                                <td className="td-center">
                                    <div className="percent-circle" style={{ 
                                        borderColor: `${getPercentColor(bonus.bonusPercent)}44`,
                                        background: `radial-gradient(circle, ${getPercentColor(bonus.bonusPercent)}15 0%, transparent 80%)`
                                    }}>
                                        <span style={{ color: getPercentColor(bonus.bonusPercent) }}>%{bonus.bonusPercent}</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="limit-card highlight">
                                        <div className="l-row"><span>Min:</span> <strong>{bonus.minDepositAmount?.toLocaleString()} ₺</strong></div>
                                        <div className="l-row max"><span>Max:</span> <strong>{bonus.maxDepositAmount === 0 ? '∞' : `${bonus.maxDepositAmount?.toLocaleString()} ₺`}</strong></div>
                                    </div>
                                </td>
                                <td>
                                    <div className="limit-card highlight">
                                        <div className="l-row"><span>Min:</span> <strong>{bonus.minAmount?.toLocaleString()} ₺</strong></div>
                                        <div className="l-row max"><span>Max:</span> <strong>{bonus.maxAmount === 0 ? '∞' : `${bonus.maxAmount?.toLocaleString()} ₺`}</strong></div>
                                    </div>
                                </td>
                                <td>
                                    <div className="panel-link-card">
                                        <FaLink className="link-icon" />
                                        <div className="link-details">
                                            <span>PID: {bonus.boPanelID}</span>
                                            <span>TYPE: {bonus.boPanelType}</span>
                                        </div>
                                    </div>
                                </td>
                                <td className="td-center">
                                    <div className={`status-pill ${bonus.status ? 'active' : 'passive'}`}>
                                        <div className="dot"></div>
                                        {bonus.status ? 'Aktif' : 'Pasif'}
                                    </div>
                                </td>
                                <td className="td-center">
                                    <button className="btn-edit-glow" onClick={() => handleEdit(bonus)}>
                                        <FaEdit />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <footer className="pagination-bar">
    <div className="pagination-info">
        Toplam <b>{filteredBonuses.length}</b> kayıttan 
        <b> {filteredBonuses.length > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0}-
        {Math.min(currentPage * itemsPerPage, filteredBonuses.length)} </b> 
        arası gösteriliyor
    </div>
    <div className="pagination-controls">
        {/* Önceki Sayfa */}
        <button 
            disabled={currentPage === 1} 
            onClick={() => paginate(currentPage - 1)} 
            className="page-nav-btn"
        >
            <FaChevronLeft />
        </button>

        {/* Dinamik Sayfa Numaraları */}
        {Array.from({ length: totalPages }, (_, index) => {
            const pageNum = index + 1;
            // Çok fazla sayfa varsa sadece mevcut sayfa çevresini göster (opsiyonel geliştirme)
            return (
                <button
                    key={pageNum}
                    onClick={() => paginate(pageNum)}
                    className={`page-number ${currentPage === pageNum ? 'active' : ''}`}
                >
                    {pageNum}
                </button>
            );
        })}

        {/* Sonraki Sayfa */}
        <button 
            disabled={currentPage >= totalPages || totalPages === 0} 
            onClick={() => paginate(currentPage + 1)} 
            className="page-nav-btn"
        >
            <FaChevronRight />
        </button>
    </div>
</footer>
            </div>

            {/* --- MODAL (Tüm Inputlar Eksiksiz) --- */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="bonus-modal">
                        <div className="modal-header">
                            <div className="m-title">
                                <FaEdit className="m-icon" />
                                <div>
                                    <h3>{currentBonus ? 'Bonusu Yapılandır' : 'Yeni Bonus Tanımı'}</h3>
                                    <span>Sistem parametrelerini güncelliyorsunuz.</span>
                                </div>
                            </div>
                            <button className="close-x" onClick={() => setShowModal(false)}><FaTimes /></button>
                        </div>

                        <form onSubmit={handleSubmit} className="modal-body">
                            <div className="form-section">
                                <h4 className="s-title">Genel Bilgiler</h4>
                                <div className="form-grid">
                                    <div className="f-group full"><label>Bonus Adı</label><input name="name" value={formData.name} onChange={handleChange} required /></div>
                                    <div className="f-group"><label>Bonus Tipi (Kod)</label><input name="bonusType" value={formData.bonusType} onChange={handleChange} required /></div>
                                    {/* KATEGORİ SEÇİMİ (Input yerine dinamik Select) */}
                                    <div className="f-group">
                                        <label>Kategori</label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleChange}
                                            className="modal-select-box" // Özel stil için class ekledik
                                            required
                                        >
                                            <option value="">Kategori Seçin...</option>
                                            {categories.map(cat => (
                                                <option key={cat._id} value={cat.categoryId}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="form-section">
                                <h4 className="s-title">Finansal Limitler & Oran</h4>
                                <div className="form-grid">
                                    <div className="f-group"><label>Bonus Yüzdesi (%)</label><input type="number" name="bonusPercent" value={formData.bonusPercent} onChange={handleChange} /></div>
                                    <div className="f-group"><label>Min. Yatırım (₺)</label><input type="number" name="minDepositAmount" value={formData.minDepositAmount} onChange={handleChange} /></div>
                                    <div className="f-group"><label>Max. Yatırım (₺)</label><input type="number" name="maxDepositAmount" value={formData.maxDepositAmount} onChange={handleChange} /></div>
                                    <div className="f-group"><label>Max. Bonus (₺)</label><input type="number" name="maxAmount" value={formData.maxAmount} onChange={handleChange} /></div>
                                </div>
                            </div>

                            <div className="form-section">
                                <h4 className="s-title">Sistem & Görünüm</h4>
                                <div className="form-grid">
                                    <div className="f-group"><label>BO Panel ID</label><input type="number" name="boPanelID" value={formData.boPanelID} onChange={handleChange} /></div>
                                    <div className="f-group"><label>BO Panel Type</label><input type="number" name="boPanelType" value={formData.boPanelType} onChange={handleChange} /></div>
                                    <div className="f-group"><label>Görünüm Sırası</label><input type="number" name="order" value={formData.order} onChange={handleChange} /></div>
                                    <div className="f-group">
                                        <label>Yayın Durumu</label>
                                        <div className={`toggle-switch ${formData.status ? 'on' : 'off'}`}
                                            onClick={() => setFormData({ ...formData, status: !formData.status })}>
                                            <div className="switch-knob"></div>
                                            <span>
                                                <small style={{ opacity: formData.status ? 0.3 : 1 }}>PASİF</small>
                                                <small style={{ opacity: formData.status ? 1 : 0.3 }}>AKTİF</small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-actions">
                                <button type="button" className="btn-cancel" onClick={() => setShowModal(false)}>İptal</button>
                                <button type="submit" className="btn-save">Değişiklikleri Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {showCategoryModal && (
    <div className="modal-overlay">
        <div className="category-manage-modal">
            <div className="modal-header">
                <div className="m-title">
                    <FaLayerGroup className="m-icon" />
                    <div>
                        <h3>Kategori Yönetimi</h3>
                        <span>Bonus kategorilerini düzenleyin veya ekleyin.</span>
                    </div>
                </div>
                <button className="close-x" onClick={() => setShowCategoryModal(false)}><FaTimes /></button>
            </div>
            
            <div className="modal-body">
                {/* Kategori Ekleme Formu */}
                <form onSubmit={handleAddCategory} className="add-cat-form">
                    <input 
                        type="text" 
                        placeholder="Yeni Kategori Adı (Örn: Slot Bonusları)" 
                        value={newCategoryName}
                        onChange={(e) => setNewCategoryName(e.target.value)}
                    />
                    <button type="submit" disabled={isSubmittingCat}>
                        {isSubmittingCat ? <FaSync className="spin" /> : <FaPlus />} Ekle
                    </button>
                </form>

                <div className="category-list">
                    <label>Mevcut Kategoriler</label>
                    {categories.map(cat => (
                        <div key={cat._id} className="cat-item">
                            <span>{cat.name} <small>(ID: {cat.categoryId})</small></span>
                            <button onClick={() => handleDeleteCategory(cat._id)} className="cat-delete-btn">
                                <FaTimes />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
)}
            <ToastContainer theme="dark" position="bottom-right" />
        </div>
    );
};

export default BonusManagement;